// DD.MM.YYYY format
const REGULAR_DATE_INTL = new Intl.DateTimeFormat('pl')

// DD mmm YYYY format
const DETAILED_DATE_INTL = new Intl.DateTimeFormat('pl', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

// DD mmm format
const DETAILED_DATE_WITHOUT_YEAR_INTL = new Intl.DateTimeFormat('pl', {
  day: 'numeric',
  month: 'short',
})

/**
 * Checks if given date is in current year
 * @param {Date} date
 * @returns {boolean}
 */
export const isDateInCurrentYear = (date) => new Date().getFullYear() === date.getFullYear()

/**
 * Returns date formatted in DD.MM.YYYY format
 * ex. "17.10.2020"
 *
 * @param {Date} date
 * @return {string}
 */
export const formatDate = (date) => REGULAR_DATE_INTL.format(date)

/**
 * Returns date formatted in DD mmm YYYY format if date is in current year
 * Or in DD mmm format if date is in other year
 * ex. "17 paź 2020" or "17 paź"
 *
 * @param {Date} date
 * @return {string}
 */
export const formatDateShort = (date) => {
  const { format } = isDateInCurrentYear(date)
    ? DETAILED_DATE_WITHOUT_YEAR_INTL
    : DETAILED_DATE_INTL
  return format(date)
}
